
import React from "react";
import BgImg from "../../assets/images/bg-3.jpg";
import ProductImg from "../../assets/images/img-1.png";
import { LiaLongArrowAltRightSolid } from "react-icons/lia";

const HomeOfferBanner = () => {
  return (
    <div id="HomeOfferBanner">
      <div className="BackgroundBannerImg">
        <img src={BgImg} alt="Background" />
      </div>

      <div className="HomeOfferBannerMain">
        {/* Left Side - Product Image */}
        <div className="HomeOfferBoxLeft">
          <div className="HomeOfferBoxImg">
            <img src={ProductImg} alt="Product" />
          </div>
        </div>

        {/* Right Side - Offer Box */}
        <div className="HomeOfferBoxRight">
          <div className="HomeOfferBox">
            <div className="HomeOfferTitle">
              <p>DEAL OF THE DAYS.</p>
            </div>
            <div className="HomeOfferDec">
              <p>Foodspring Whey Protein</p>
            </div>
            <div className="HomeOfferPrice">
              <p className="newPrice">$40.00</p>
              <p className="oldPrice">$60.00</p>
            </div>

            <div className="HomeOfferCountDown">
              <div className="CountdownBox"><p>587</p></div>
              <div className="CountdownBox"><p>15</p></div>
              <div className="CountdownBox"><p>54</p></div>
              <div className="CountdownBox"><p>36</p></div>
            </div>

            <div className="ShopnowBtn">
              <button>Shop Now</button>
              <LiaLongArrowAltRightSolid className="arrowIcon" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeOfferBanner;
